import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "广告图", -1)
const _hoisted_3 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "ps-4 rounded-start w-200px" }, [
      /*#__PURE__*/_createTextVNode("轮播图片"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("small", { class: "fw-normal text-gray-500" }, "建议 1400×520 px")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "ps-4 rounded-start w-200px" }, [
      /*#__PURE__*/_createTextVNode("广告图片"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("small", { class: "fw-normal text-gray-500" }, "建议 1400×520 px")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "ps-4 rounded-start w-200px" }, [
      /*#__PURE__*/_createTextVNode("内容图片"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("small", { class: "fw-normal text-gray-500" }, "建议宽度 750 px")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "链接"),
    /*#__PURE__*/_createElementVNode("th", { class: "w-80px" }, "首页广告"),
    /*#__PURE__*/_createElementVNode("th", { class: "w-30px" })
  ])
], -1)
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("保存")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_plus = _resolveComponent("plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_delete = _resolveComponent("delete")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      rules: _ctx.rules,
      model: _ctx.banners,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("table", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banners, (item, idx) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (item._destroy != 1)
                  ? (_openBlock(), _createElementBlock("tr", {
                      key: item.id || idx
                    }, [
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_upload, {
                          class: "avatar-uploader",
                          action: "https://jsonplaceholder.typicode.com/posts/",
                          "show-file-list": false,
                          "auto-upload": false,
                          ref: "uploadRef",
                          onChange: ($event: any) => (_ctx.onImageChange($event, item))
                        }, {
                          default: _withCtx(() => [
                            (item.image_url)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: item.image_url,
                                  class: "avatar"
                                }, null, 8, _hoisted_5))
                              : (_openBlock(), _createBlock(_component_el_icon, {
                                  key: 1,
                                  class: "avatar-uploader-icon"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_plus)
                                  ]),
                                  _: 1
                                }))
                          ]),
                          _: 2
                        }, 1032, ["onChange"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_upload, {
                          class: "avatar-uploader",
                          action: "https://jsonplaceholder.typicode.com/posts/",
                          "show-file-list": false,
                          "auto-upload": false,
                          ref: "uploadRef",
                          onChange: ($event: any) => (_ctx.onIndexImageChange($event, item))
                        }, {
                          default: _withCtx(() => [
                            (item.index_image_url)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: item.index_image_url,
                                  class: "avatar"
                                }, null, 8, _hoisted_6))
                              : (_openBlock(), _createBlock(_component_el_icon, {
                                  key: 1,
                                  class: "avatar-uploader-icon"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_plus)
                                  ]),
                                  _: 1
                                }))
                          ]),
                          _: 2
                        }, 1032, ["onChange"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_upload, {
                          class: "avatar-uploader",
                          action: "https://jsonplaceholder.typicode.com/posts/",
                          "show-file-list": false,
                          "auto-upload": false,
                          ref: "uploadRef",
                          onChange: ($event: any) => (_ctx.onDetailImageChange($event, item))
                        }, {
                          default: _withCtx(() => [
                            (item.detail_image_url)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: item.detail_image_url,
                                  class: "avatar"
                                }, null, 8, _hoisted_7))
                              : (_openBlock(), _createBlock(_component_el_icon, {
                                  key: 1,
                                  class: "avatar-uploader-icon"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_plus)
                                  ]),
                                  _: 1
                                }))
                          ]),
                          _: 2
                        }, 1032, ["onChange"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_input, {
                          modelValue: item.link,
                          "onUpdate:modelValue": ($event: any) => ((item.link) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((item.is_index) = $event)
                        }, null, 8, _hoisted_8), [
                          [_vModelCheckbox, item.is_index]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          onClick: ($event: any) => (_ctx.handleRemove(item))
                        }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_delete)
                            ]),
                            _: 1
                          })
                        ], 8, _hoisted_9)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 256))
          ])
        ]),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.onNew
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSubmit(_ctx.formRef)))
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["rules", "model"])
  ]))
}